import type { BillingCurrency } from '@contracts/payment/Currency';
import type { ReviewableOrder } from '@src/orders/domain/ReviewableOrder';
import { useUpdateReviewableOrder } from '@src/orders/hooks/useReviewableOrder';
import { OrdersClient } from '@src/orders/services/OrdersClient';
import { useMutation } from '@tanstack/react-query';

export const useUpdateBillingCurrency = ({
  order,
}: {
  order: ReviewableOrder;
}) => {
  const { updateReviewableOrder } = useUpdateReviewableOrder();
  const { mutate: updateBillingCurrency } = useMutation({
    mutationFn: ({ billingCurrency }: { billingCurrency: BillingCurrency }) =>
      OrdersClient.updateBillingCurrency({
        orderId: order.id,
        billingCurrency,
      }),
    onSuccess: (updatedOrder) => {
      updateReviewableOrder({ updatedOrder });
    },
  });

  return {
    updateBillingCurrency,
  };
};
